import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ErrorTriangle = function ErrorTriangle() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "20",
    height: "17",
    viewBox: "0 0 20 17",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Warning Icon: Exclamation Inside Red Triangle"
    }), /*#__PURE__*/_jsxs("g", {
      "aria-hidden": "true",
      fill: "none",
      fillRule: "nonzero",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#FB5352",
        d: "M10.868 1.02l8.277 14.484A1 1 0 0 1 18.277 17H1.723a1 1 0 0 1-.868-1.496L9.132 1.019a1 1 0 0 1 1.736 0z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FFF",
        d: "M9 5h2v6H9z"
      }), /*#__PURE__*/_jsx("rect", {
        width: "3",
        height: "3",
        x: "8.5",
        y: "12.5",
        fill: "#FFF",
        rx: "1.5"
      })]
    })]
  });
};
/* eslint-disable max-len, react/prop-types */


export default ErrorTriangle;